import React from 'react';
import {generatePath, useSearchParams} from 'react-router';

import {skipToken} from '@reduxjs/toolkit/query';

import {ClientPageHeader} from 'src/components';
import {useGetAgentClientQuery} from 'src/containers/LeadCompanyClients';
import PATHS from 'src/paths';

export const getSupportPath = (
  path: string,
  {
    tenantId = '',
    id = '',
    params = {},
  }: {tenantId?: string; id?: string; params?: Record<string, string>},
) => `${generatePath(path, {tenantId, ...params})}?${new URLSearchParams({id})}`;

export const SupportHeader = React.memo<{tenantId?: string}>(({tenantId = ''}) => {
  const [searchParams] = useSearchParams();
  const id = searchParams.get('id') || '';

  const {data: agentClient} = useGetAgentClientQuery(tenantId ? {tenantId} : skipToken);

  const backPath = React.useMemo(() => {
    const path = generatePath(PATHS.COMPANY_AGENT_CLIENT_CARD, {id});

    return `${path}?${new URLSearchParams({tenantId})}`;
  }, [id, tenantId]);

  if (!tenantId) {
    return null;
  }

  return <ClientPageHeader title={agentClient?.companyName} backPath={backPath} />;
});

SupportHeader.displayName = 'SupportHeader';
